
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4504|8022|9762)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
